export default {
  data: {
    title: {
      fr: "Souveraineté et sécurité des données,\nvos données brutes restent sur site.",
      en: "Data sovereignty and security,\nyour raw data stays on-site.",
    },
    description: {
      description1: {
        fr: "<strong>Architecture décentralisée :</strong> Les données brutes restent hébergées sur le Edge Computer sans <strong>aucune dépendance à un cloud externe ou à un serveur local.</strong>",
        en: "Raw data remains hosted on the Edge Computer with <strong>no dependency on external cloud services or local servers.</strong>",
      },
      description3: {
        fr: "<strong>Synchronisations cloud limitées :</strong> les échanges vers le cloud ne concernent que de la donnée agrégée, anonymisée et chiffrée.",
        en: "<strong>Limited cloud synchronization:</strong> only aggregated, anonymized and encrypted data is exchanged with the cloud.",
      },
    },
  },
};
